import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button, Hidden } from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

function handleLogout(instance:any) {
    instance.logoutPopup().catch(e => {
        console.error(e);
    });
}

/**
 * Renders a button which, when selected, will open a popup for logout
 */
export const LogoutButton = () => {
    const { instance } = useMsal();

    return (
        <Button onClick={() => handleLogout(instance)}><ExitToAppIcon />  <Hidden smDown>
            Sign Out
        </Hidden></Button>
    );
}

export default LogoutButton